import React, { useContext, useState, useEffect } from "react";
import LightBoxSetting from "./LightBoxSetting";
import LightboxListing from "./LightBoxListing";
import { EditorInfoContext } from "../../../../../../../utils/userInfoContext";
import "./LightBoxSection.css";

const LightBoxSection = ({ docFileId, docId, handleClose, view: key, setView: setKey }) => {
  const { setEditLightBox } = useContext(EditorInfoContext);
  const [isViewLightBoxOpen, setIsViewLightBoxOpen] = useState(false);

  const resetLightboxState = () => {
    setEditLightBox({});
  };

  useEffect(() => {
    const handleEscPress = (event) => {
      if (event.key === "Escape" && !isViewLightBoxOpen) {
        event.stopPropagation();
        handleClose();
      }
    };

    document.addEventListener("keydown", handleEscPress);
    return () => document.removeEventListener("keydown", handleEscPress);
  }, [isViewLightBoxOpen]);

  return (
    <div className="p-2 lightbox-setting lb-panel">
      {key === "list" ? (
        <LightboxListing
          docFileId={docFileId}
          setKey={setKey}
          resetLightboxState={resetLightboxState}
          setEditLightBox={setEditLightBox}
          setIsViewLightBoxOpen={setIsViewLightBoxOpen}
        />
      ) : (
        <LightBoxSetting docFileId={docFileId} docId={docId} setKey={setKey} handleClose={handleClose} />
      )}
    </div>
  );
};
export default LightBoxSection;
